import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export function fetchUsersWithScope(scopeName) {
  const portalId = PortalIdParser.get();
  return http.get(`users/v2/app/scopes/${scopeName}/hubs/${portalId}/user-ids`);
}